const dictionary = {
  en: {
    // -----------------------------------------------------------------------------------------------
    // 기부 신청서 start
    // -----------------------------------------------------------------------------------------------
    dntn_aplc_001: 'e주문번호가 존재하지 않습니다.',
    dntn_aplc_002: 'e이름을 입력해 주세요.',
    dntn_aplc_003: 'e주민번호를 입력해 주세요.',
    dntn_aplc_004: 'e주민번호가 유효하지 않습니다.',
    dntn_aplc_005: 'e필수사항에 모두 동의하셔야 기부하실수 있습니다.',
    dntn_aplc_006: 'e이미 기부 신청 되었습니다.',
    dntn_aplc_007: 'e기부신청 하시겠습니까?',
    dntn_aplc_008: 'e기부신청이 완료 되었습니다.',
    dntn_aplc_009: 'e기부신청시 오류가 발생하였습니다.',
    dntn_aplc_010: 'e조회시 오류가 발생하였습니다.'
    // -----------------------------------------------------------------------------------------------
    // 기부 신청서 end
    // -----------------------------------------------------------------------------------------------
  }
}

export default {
  getDictionary () {
    return dictionary
  }
}



// WEBPACK FOOTER //
// ./src/locale/purchase/purchase-dict-en.js